import { Col, Input, Row, Select, Table } from "antd";
import { Field, Form, Formik } from "formik";
import React, { FC, useEffect, useRef, useState } from "react";
import PaginationComponent from "../../../shared/components/PaginationComponent";
import ButtonComponent from "../../../shared/components/ButtonComponent";
import { SearchOutlined } from "@ant-design/icons";

import { deserialize } from "serializr";
import { ExamService } from "../../../services/ExamService/exam.service";
import CommonService from "../../../services/CommonService/common.service";
import BranchService from "../../../services/InstituteService/branch.service";
import SectionService from "../../../services/InstituteService/section.service";
import LeaderboardService from "../../../services/LeaderboardService/leaderboard.service";

import { MetaModel } from "../../../models/CourseModels/SubjectModel/subject.model";
import { FilterLeaderboard, Leaderboard, } from "../../../models/LeaderboardModel/Leaderboard.model";
import { BranchClassRoomsModel } from "../../../models/InstituteModel/branches.model";
import { PaginationModel } from "../../../models/PaginationModel/pagination.model";

interface ExamLeaderboardProps {
  institutes: MetaModel[];
  user: any
}
const ExamLeaderboard: FC<ExamLeaderboardProps> = ({ institutes, user }) => {
  const [initialValues, setInitialValues] = useState<any>({
    type: "institute",
  });
  const [branches, setBranches] = useState<MetaModel[]>([]);
  const [exams, setExams] = useState<MetaModel[]>([]);
  const [branchClassRooms, setBranchClassRooms] = useState<MetaModel[]>([]);
  const [sections, setSections] = useState<MetaModel[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [leaderboardData, setLeaderboardData] = useState<Leaderboard[]>([]);
  const [paginationMeta, setPaginationMeta] = useState<PaginationModel>({});
  const [currentPageNumber, setCurrentPageNumber] = useState<number>(1);
  const [query, setQuery] = useState<FilterLeaderboard>({});

  const formRef = useRef<any>();


  useEffect(() => {
    if (institutes.length && user?.roleName === "instituteadmin") {
      let currentInstituteID = Number(institutes[0].value)
      setInitialValues({ ...initialValues, instituteId: currentInstituteID })
      fetchBranches(currentInstituteID)
    }
  }, [institutes])


  const handleSubmit = (values: FilterLeaderboard) => {
    setLoading(true);
    setQuery(values);
    LeaderboardService.fetchExamLeaderboard(
      values,
      (data, meta) => {
        setLeaderboardData(data);
        setPaginationMeta(meta);
      },
      () => { },
      () => {
        setLoading(false);
      }
    );
  };

  const fetchBranches = (id: number) => {
    CommonService.fetchBranchesMeta(
      id,
      (data) => {
        const response = deserialize(MetaModel, data) as MetaModel[];
        setBranches(response);
      },
      () => { },
      () => { }
    );
  };

  const fetchSections = (instituteId: number, branchId: number) => {
    SectionService.fetchSections(
      { institute_id: instituteId, branch_id: branchId },
      (sections, meta) => {
        const response = deserialize(MetaModel, sections) as MetaModel[];
        setSections(response);
      },
      () => { },
      () => { }
    );
  };

  const fetchExams = () => {
    LeaderboardService.fetchExamsMeta(
      (exams) => {
        const data = deserialize(MetaModel, exams) as MetaModel[];
        setExams(data);
      },
      (error: any) => { },
      () => { }
    );
  };

  const fetchBranchClassRooms = (id: number) => {
    SectionService.fetchBranchClassRooms(
      { branch_id: id },
      (classrooms: BranchClassRoomsModel[]) => {
        let meta: any = classrooms?.map((value, index) => {
          return {
            label: value?.name,
            value: value?.id,
            id: value?.classRoom?.id,
          };
        });
        setBranchClassRooms([...meta]);
      },
      () => { },
      () => { }
    );
  };

  const handlePageChange = (page: number, pageSize: any) => {
    handleSubmit({ ...query, page });
    setCurrentPageNumber(page);
  };

  useEffect(() => {
    fetchExams();
  }, []);

  return (
    <div className="exam-leaderboard">
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        enableReinitialize
        innerRef={formRef}
      >
        {({ setFieldValue, values, resetForm, dirty }) => {
          return (
            <Form placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <div className="institute-leaderboard-filters__container">
                <Row
                  className="classroom-leaderboard-filters__wrapper"
                  gutter={24}
                >
                  <Col span={18}>
                    <Row gutter={[24, 24]}>
                      <Col span={8}>
                        <div className="institute-leaderboard-filter-field__container">
                          <div className="institute-leaderboard-filter-field__label">
                            Filter by
                          </div>
                          <Field
                            disabled={user?.roleName === "instituteadmin" ? true : false}
                            as={Select}
                            name="type"
                            value={values?.type}
                            options={[
                              {
                                value: "institute",
                                label: "Institute",
                              },
                              {
                                value: "onboard",
                                label: "Self onboarded",
                              },
                            ]}
                            placeholder="Select Filter"
                            onChange={(value) => {
                              resetForm();
                              setFieldValue("type", value);
                            }}
                          ></Field>
                        </div>
                      </Col>
                      {values?.type == "institute" && (
                        <>
                          <Col span={8}>
                            <div className="institute-leaderboard-filter-field__container">
                              <div className="institute-leaderboard-filter-field__label">
                                Institute
                              </div>
                              <Field
                                disabled={user?.roleName === "instituteadmin" ? true : false}
                                as={Select}
                                options={institutes}
                                name="instituteId"
                                value={values?.instituteId}
                                placeholder="Select Institute"
                                onChange={(value) => {
                                  setFieldValue("instituteId", value);
                                  fetchBranches(value);
                                }}
                              ></Field>
                            </div>
                          </Col>
                          <Col span={8}>
                            <div className="institute-leaderboard-filter-field__container">
                              <div className="institute-leaderboard-filter-field__label">
                                Branch
                              </div>
                              <Field
                                as={Select}
                                name="branchId"
                                value={values?.branchId}
                                options={branches}
                                placeholder="Select Branch"
                                onChange={(value) => {
                                  setFieldValue("branchId", value);
                                  fetchBranchClassRooms(value);
                                }}
                              ></Field>
                            </div>
                          </Col>
                        </>
                      )}
                      <Col span={8}>
                        <div className="institute-leaderboard-filter-field__container">
                          <div className="institute-leaderboard-filter-field__label">
                            Exam
                          </div>
                          <Field
                            as={Select}
                            name="examId"
                            options={exams}
                            value={values?.examId}
                            placeholder="Select Exam"
                            onChange={(value) => setFieldValue("examId", value)}
                          ></Field>
                        </div>
                      </Col>
                      {values?.type !== "onboard" && (
                        <Col span={8}>
                          <div className="institute-leaderboard-filter-field__container">
                            <div className="institute-leaderboard-filter-field__label">
                              Class
                            </div>
                            <Field
                              as={Select}
                              name="branchClassRoomId"
                              options={branchClassRooms}
                              value={values?.branchClassRoomId}
                              placeholder="Select Class"
                              onChange={(value) => {
                                setFieldValue("branchClassRoomId", value);
                                values?.instituteId &&
                                  fetchSections(values?.instituteId, value);
                              }}
                            ></Field>
                          </div>
                        </Col>
                      )}
                      {values?.type == "institute" && (
                        <Col span={8}>
                          <div className="institute-leaderboard-filter-field__container">
                            <div className="institute-leaderboard-filter-field__label">
                              Section
                            </div>
                            <Field
                              as={Select}
                              name="sectionId"
                              options={sections}
                              value={values?.sectionId}
                              placeholder="Select Section"
                              onChange={(value) =>
                                setFieldValue("sectionId", value)
                              }
                            ></Field>
                          </div>
                        </Col>
                      )}
                    </Row>
                  </Col>
                  <Col span={6}>
                    <div className="institute-leaderboard-filter-btn__wrapper">
                      <ButtonComponent
                        type="text"
                        buttonContent={"Clear Filters"}
                        onClick={() => {
                          resetForm();
                          setLeaderboardData([]);
                          setQuery({});
                          setLoading(false);
                        }}
                      />
                      <ButtonComponent
                        type="primary"
                        loading={loading}
                        buttonContent={"Apply Filters"}
                        onClick={() => handleSubmit(values)}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
              <div className="institute-leaderboard-search__container">
                <Input
                  placeholder={
                    values?.type == "onboard"
                      ? "Search by student name, phone number, board ..."
                      : "Search by any branch, class, section ..."
                  }
                  prefix={<SearchOutlined />}
                  onChange={(e) => {
                    handleSubmit({ ...query, search: e.target.value });
                  }}
                  disabled={query ? false : true}
                />
                {leaderboardData?.length ? (
                  <p>
                    Showing results{" "}
                    {leaderboardData?.length == paginationMeta?.totalCount
                      ? paginationMeta?.totalCount
                      : (currentPageNumber - 1) * leaderboardData?.length +
                      1 +
                      " - " +
                      ((currentPageNumber - 1) * 20 +
                        leaderboardData?.length)}
                    /<span>{paginationMeta?.totalCount}</span>
                  </p>
                ) : (
                  ""
                )}
              </div>
            </Form>
          );
        }}
      </Formik>
      <Table
        columns={[
          {
            title: "Rank",
            key: "rank",
            dataIndex: "rank",
            render: (rank: number) => {
              return rank == 1 ? (
                <div className="first__rank">{rank}</div>
              ) : rank == 2 ? (
                <div className="second__rank">{rank}</div>
              ) : rank == 3 ? (
                <div className="third__rank">{rank}</div>
              ) : (
                <div className="rank">{rank}</div>
              );
            },
            sorter: (a: any, b: any) => a?.rank - b?.rank,
          },
          {
            title: "Points",
            dataIndex: "cummulativeScore",
            key: "cummulativeScore",
          },
          {
            title: "ID",
            dataIndex: "studentId",
            key: "studentId",
          },
          {
            title: "Name",
            dataIndex: "name",
            key: "name",
          },
          {
            title: "Class",
            dataIndex: "classRoom",
            key: "classRoom",
          },
          {
            title: "Phone number",
            dataIndex: "phoneNumber",
            key: "phoneNumber",
          },
          {
            title: "Email ID",
            dataIndex: "email",
            key: "email",
          },
        ]}
        dataSource={leaderboardData}
        pagination={false}
      />
      <PaginationComponent
        handlePageChange={handlePageChange}
        paginationMeta={paginationMeta}
      />
    </div>
  );
};

export default ExamLeaderboard;
